<template>
  <div class="w-full lg:h-full">
    <div class="py-8 text-center text-xl font-bold">
      Toutes les factures de vos commandes passées en tant que particulier sont
      maintenant disponible dans le nouvel Espace Gestion.
    </div>
  </div>
</template>
<script>
  export default {};
</script>
<style lang="scss" scoped></style>
